
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { PuttingResult } from "@/types/puttingResults";
import { filterByLevel } from "@/utils/puttingResults/formatUtils";
import { prepareChartData } from "@/utils/puttingResults/chartUtils";

/**
 * Shared utility functions for putting hooks
 */

export const useSessionCheck = () => {
  const navigate = useNavigate();
  
  /**
   * Checks if user is authenticated and returns userId
   * @returns User ID if authenticated, or redirects to auth page
   */
  const checkSession = async (): Promise<string> => {
    const { data: session } = await supabase.auth.getSession();
    
    if (!session.session) {
      navigate("/auth");
      return "";
    }
    
    return session.session.user.id;
  };
  
  return { checkSession };
};

/**
 * Process results data for UI consumption
 */
export const processResultsData = (results: PuttingResult[]) => {
  // Process data for charts
  const chartData = prepareChartData(results);

  // Filter results by level - ensure strict string comparison
  const level1Results = filterByLevel(results, "1");
  const level2Results = filterByLevel(results, "2");
  const level3Results = filterByLevel(results, "3");
  
  return {
    chartData,
    level1Results,
    level2Results,
    level3Results
  };
};
